export default {"src":"/_next/static/image/public/images/flags/flag_690.79af40b08db6fc251392e37c8d80e7dd.svg","height":16,"width":24};